import { render, staticRenderFns } from "./mail-template.dialogue.vue?vue&type=template&id=20a5b5cf&scoped=true"
import script from "./mail-template.dialogue.vue?vue&type=script&lang=js"
export * from "./mail-template.dialogue.vue?vue&type=script&lang=js"
import style0 from "./mail-template.dialogue.vue?vue&type=style&index=0&id=20a5b5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5b5cf",
  null
  
)

export default component.exports